import { API_URLS } from '../../constants/apiConstants';
import { CONTENT_TYPE } from '../../constants/commonConstants';
import { getContentTypeFromMediaCode } from './getContentTypeFromMediaCode';
/**
 * 요청 API URL 및 응답값의 VOD 정보로부터 program, movie, episode, channel 값을 추출합니다.
 * @param bandApiUrl
 * @param itemResponse
 */
var getProgramMovieEpisodeChannel = function (bandApiUrl, itemResponse) {
    var program;
    var movie;
    var episode;
    var channel;
    var seasonMovie;
    switch (bandApiUrl) {
        case API_URLS.HIGHLIGHT: {
            var highlightResult = itemResponse;
            var vodContent = highlightResult.content;
            if (vodContent) {
                program = vodContent.program;
                movie = vodContent.movie;
                episode = vodContent.episode;
                channel = vodContent.channel;
            }
            break;
        }
        case API_URLS.STREAM_INFO:
        case API_URLS.EPISODE:
        case API_URLS.MOVIE:
        case API_URLS.EPISODES:
        case API_URLS.FREQUENCY_PROGRAM:
        case API_URLS.MOVIES: {
            var vodContent = itemResponse;
            program = vodContent.program;
            movie = vodContent.movie;
            episode = vodContent.episode;
            channel = vodContent.channel;
            break;
        }
        case API_URLS.FAN_CONTENTS: {
            var fanContentResult = itemResponse;
            var vodContent = fanContentResult.content;
            program = vodContent.program;
            movie = vodContent.movie;
            episode = vodContent.episode;
            channel = vodContent.channel;
            break;
        }
        case API_URLS.PURCHASED_EPISODE:
        case API_URLS.PURCHASED_MOVIE: {
            var purchaseResult = itemResponse;
            var vodContent = purchaseResult.CONTENT_RESULT;
            program = vodContent === null || vodContent === void 0 ? void 0 : vodContent.program;
            movie = vodContent === null || vodContent === void 0 ? void 0 : vodContent.movie;
            episode = vodContent === null || vodContent === void 0 ? void 0 : vodContent.episode;
            channel = vodContent === null || vodContent === void 0 ? void 0 : vodContent.channel;
            break;
        }
        case API_URLS.KIDS_POPULAR:
        case API_URLS.KIDS_MOVIES:
        case API_URLS.KIDS_CHARACTER:
        case API_URLS.KIDS_CREATOR: {
            var kidsResult = itemResponse;
            program = kidsResult.program;
            movie = kidsResult.movie;
            episode = kidsResult.episode;
            break;
        }
        case API_URLS.MY_LASTS_TV: {
            var myLastsResult = itemResponse;
            var vodContent = myLastsResult.content;
            program = vodContent.program;
            movie = vodContent.movie;
            episode = vodContent.episode;
            channel = vodContent.channel;
            break;
        }
        case API_URLS.PROGRAM: {
            program = itemResponse;
            break;
        }
        case API_URLS.RECOMMEND:
        case API_URLS.RECOMMEND_MOVIE_LIKE: {
            var recommendMetaContentInfo = itemResponse;
            var vodContent = recommendMetaContentInfo.meta;
            program = vodContent.program;
            movie = vodContent.movie;
            episode = vodContent.episode;
            channel = vodContent.channel;
            break;
        }
        case API_URLS.RECOMMEND_MOVIE_SIMILAR: {
            var vodContent = itemResponse;
            movie = vodContent.movie;
            break;
        }
        case API_URLS.RECOMMEND_MOVIE_ASSOCIATE: {
            movie = itemResponse;
            movie.category1_name = {
                ko: itemResponse.category_name,
            };
            break;
        }
        case API_URLS.RECOMMEND_PROGRAM_ASSOCIATE: {
            program = itemResponse;
            program.category1_name = {
                ko: itemResponse.category_name,
            };
            break;
        }
        case API_URLS.CONTENT_INFO: {
            var contentType = getContentTypeFromMediaCode(itemResponse.code);
            if (contentType === CONTENT_TYPE.MOVIE) {
                movie = itemResponse;
                movie.category1_name = {
                    ko: itemResponse.category_name,
                };
            }
            else {
                program = itemResponse;
                program.category1_name = {
                    ko: itemResponse.category_name,
                };
                episode = itemResponse;
                episode.category1_name = {
                    ko: itemResponse.category_name,
                };
            }
            channel = {
                name: {
                    ko: itemResponse.channel,
                },
            };
            break;
        }
        case API_URLS.RECOMMEND_CATEGORY: {
            var vodContent = itemResponse;
            program = vodContent.program;
            episode = vodContent.episode;
            break;
        }
        case API_URLS.ORIGINALS:
        case API_URLS.ORIGINALS_BAND: {
            var contentType = getContentTypeFromMediaCode(itemResponse.vod_code);
            if (contentType === CONTENT_TYPE.MOVIE) {
                movie = itemResponse;
                movie.category1_name = {
                    ko: itemResponse.category_name,
                };
            }
            else if (contentType === CONTENT_TYPE.PROGRAM) {
                program = itemResponse;
                program.category1_name = {
                    ko: itemResponse.category_name,
                };
            }
            else {
                episode = itemResponse;
                episode.category1_name = {
                    ko: itemResponse.category_name,
                };
            }
            channel = {
                name: {
                    ko: itemResponse.channel_name,
                },
            };
            break;
        }
        case API_URLS.SEASON_MOVIE:
            seasonMovie = itemResponse;
            break;
        default:
            break;
    }
    return {
        movie: movie,
        program: program,
        episode: episode,
        channel: channel,
        seasonMovie: seasonMovie,
    };
};
export default getProgramMovieEpisodeChannel;
